import React from "react";
import { motion } from "framer-motion";
import { ChevronDown, Users } from "lucide-react";

const HEADER_IMG = "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69b41710d6b60acb7a810a52/3a1b1260c_header_img.png";

export default function HeroSection({ onScrollToForm, loggedIn }) {
  return (
    <section className="relative flex flex-col items-center pt-20 pb-0 overflow-hidden" dir="rtl">

      {/* Text content over background */}
      <div className="relative z-10 text-center max-w-3xl mx-auto w-full px-4 pt-10 pb-8">

        {/* Urgency badge */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.05 }}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-5 text-sm font-bold"
          style={{ background: "#fff3e0", border: "1.5px solid #fb923c", color: "#c2410c" }}
        >
          <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse inline-block" />
          המבצע פעיל · 22.3 – 31.3.2026
        </motion.div>

        {/* Pre-headline */}
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-lg md:text-xl font-bold mb-3 leading-relaxed"
          style={{ color: "rgba(255,255,255,0.92)" }}
        >
          הכרטיסים ל-Tomorrowland אזלו? <span style={{ color: "#4ade80" }}>לא לקהילת Mom3ntum.</span><br />
          הצטרפו לקהילה, תתרגלו לרכוש כרטיסים במחירי עלות!<br />
          ואולי תטוסו למשחק הפתיחה של מונדיאל 2026 – עלינו! 🏆✈️<br />
          <span className="text-base font-semibold" style={{ color: "rgba(255,255,255,0.75)" }}>והכל בידיים שלכם!</span>
        </motion.p>

        {/* Main headline */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.18 }}
          className="font-black leading-tight mb-6"
          style={{ color: "#ffffff", fontSize: "clamp(1.8rem, 5vw, 3.4rem)" }}
        >
          כן כן, זוג כרטיסים למונדיאל
          <span className="block" style={{
            background: "linear-gradient(90deg, #16a34a, #4ade80)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text"
          }}>
            ארה"ב מקסיקו 2026 — עלינו! 🏆
          </span>
        </motion.h1>

      </div>

      {/* Hero image - full width, above CTA */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.32 }}
        className="w-full relative z-10 px-4"
        style={{ maxWidth: "900px", margin: "0 auto" }}
      >
        <img
          src={HEADER_IMG}
          alt="Mom3ntum - Tomorrowland & World Cup 2026"
          className="w-full object-contain"
          style={{ borderRadius: "24px", boxShadow: "0 8px 40px rgba(0,0,0,0.5)" }}
        />
      </motion.div>

      {/* Subtitle - below image, above CTA */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="relative z-10 text-center px-4 pt-8 max-w-2xl mx-auto"
        dir="rtl"
      >
        <p className="text-base md:text-lg leading-relaxed" style={{ color: "rgba(255,255,255,0.82)" }}>
          שמים סוף לספסרות! קהילת Mom3ntum פותחת דלתות לאירועים הכי מבוקשים בעולם במחירי העלות המקוריים (Face Value).
          הצטרפו עכשיו, הבטיחו גישה לכרטיסים שכולם מחפשים, והיכנסו אוטומטית למבצע הענק שלנו.
        </p>
      </motion.div>

      {/* CTA - below image */}
      <div className="relative z-10 text-center px-4 py-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.42 }}
          className="flex flex-col items-center gap-3"
        >
          <button
            onClick={() => {
              if (loggedIn) {
                onScrollToForm?.();
              } else {
                const currentPath = window.location.pathname;
                window.location.href = `/SignIn?next=${encodeURIComponent(currentPath)}`;
              }
            }}
            className="inline-flex items-center gap-2 font-black text-lg px-10 py-4 rounded-full transition-all duration-200 active:scale-95 group"
            style={{
              background: "linear-gradient(135deg, #16a34a, #15803d)",
              color: "#ffffff",
              boxShadow: "0 8px 32px rgba(22,163,74,0.4)"
            }}
          >
            {loggedIn ? "👉 רוצה להתחיל לצבור נקודות? 👈" : "👉 אני רוצה להצטרף לקהילה ולהיכנס למבצע! 👈"}
            <ChevronDown className="w-5 h-5 group-hover:translate-y-1 transition-transform" />
          </button>
          <span className="flex items-center gap-1.5 text-sm font-medium" style={{ color: "rgba(255,255,255,0.7)" }}>
            <Users className="w-4 h-4" />
            הרשמה חינמית · ללא התחייבות
          </span>
        </motion.div>
      </div>

    </section>
  );
}